var exports = {
  "_J": "xfd349460--98523a--nav_container" + " " + __webpack_require__(33767)["sectorWithSticky"],
  "DD": "xfd349460--98523a--title",
  "M5": "xfd349460--98523a--promos-list",
};

module.exports = exports;
